import { useState } from 'react';
import useControlledState from '../useControlledState';

interface UseOpenManagerProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

interface UseOpenManagerReturn {
  isOpen: boolean;
  /**
   * Whether the view has been opened at least once.
   * It's used to keep the view mounted in the DOM to prevent content recreation on re-display.
   * This is particularly beneficial for content with network requests.
   */
  hasBeenOpened: boolean;
  onIsOpenChange: (open: boolean) => void;
}

/**
 * A utility hook to manage the open state of a popover.
 */
const useOpenManager = ({
  open,
  onOpenChange,
}: UseOpenManagerProps): UseOpenManagerReturn => {
  const [isOpen, setIsOpen] = useControlledState({
    defaultValue: false,
    value: open,
    onValueChange: onOpenChange,
  });
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  if (isOpen && !hasBeenOpened) {
    setHasBeenOpened(true);
  }

  return { isOpen, hasBeenOpened, onIsOpenChange: setIsOpen };
};

export default useOpenManager;
